import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/antd";
import { Typography, Tag } from "antd";

import { AdminPodcastInfo } from "interfaces";

const { Title, Text } = Typography;

export const PodcastShow: React.FC = () => {
  const { query, result: record } = useShow<AdminPodcastInfo>();
  const { isLoading } = query;

    return (
    <Show isLoading={isLoading}>
      <Title level={5}>Status</Title>
      <Text>
        {record?.is_deleted
          ? <Tag color="red">Deleted — hidden from the site and search</Tag>
          : <Tag color="green">Live</Tag>}
      </Text>

      <Title level={5}>iTunes ID</Title>
      <Text>{record?.itunes_id}</Text>

      <Title level={5}>Title</Title>
      <Text>{record?.title}</Text>

      <Title level={5}>Author</Title>
      <Text>{record?.author}</Text>

      <Title level={5}>RSS</Title>
      <Text><a href={record?.link_rss || undefined}>{record?.link_rss}</a></Text>

      <Title level={5}>iTunes</Title>
      <Text><a href={record?.link_itunes || undefined}>{record?.link_itunes}</a></Text>

      <Title level={5}>Google</Title>
      <Text><a href={record?.link_google || undefined}>{record?.link_google}</a></Text>

      <Title level={5}>Spotify</Title>
      <Text><a href={record?.link_spotify || undefined}>{record?.link_spotify}</a></Text>

      <Title level={5}>Yandex</Title>
      <Text><a href={record?.link_yandex || undefined}>{record?.link_yandex}</a></Text>

      <Title level={5}>VK</Title>
      <Text><a href={record?.link_vk || undefined}>{record?.link_vk}</a></Text>

      <Title level={5}>Soundstream</Title>
      <Text><a href={record?.link_soundstream || undefined}>{record?.link_soundstream}</a></Text>

      <Title level={5}>Castbox</Title>
      <Text><a href={record?.link_castbox || undefined}>{record?.link_castbox}</a></Text>

      <Title level={5}>Stitcher</Title>
      <Text><a href={record?.link_stitcher || undefined}>{record?.link_stitcher}</a></Text>

      <Title level={5}>Overcast</Title>
      <Text><a href={record?.link_overcast || undefined}>{record?.link_overcast}</a></Text>

      <Title level={5}>PocketCasts</Title>
      <Text><a href={record?.link_pocketcasts || undefined}>{record?.link_pocketcasts}</a></Text>

      <Title level={5}>PlayerFM</Title>
      <Text><a href={record?.link_playerfm || undefined}>{record?.link_playerfm}</a></Text>

      <Title level={5}>Castro</Title>
      <Text><a href={record?.link_castro || undefined}>{record?.link_castro}</a></Text>

      <Title level={5}>Breaker</Title>
      <Text><a href={record?.link_breaker || undefined}>{record?.link_breaker}</a></Text>

      <Title level={5}>RadioPublic</Title>
      <Text><a href={record?.link_radiopublic || undefined}>{record?.link_radiopublic}</a></Text>

    </Show>
  );
};
